import React from "react";

import "./important-field-asterik.styles.scss";

const ImportantFieldAsterik = () => {
  return <p className="important-field-asterik-atom">&nbsp;*</p>;
};

export default ImportantFieldAsterik;
